import { LinkedinConnectorIcon, LinkedinWhiteConnectorIcon } from '@/assets';
import { AccountSelection } from '../AccountSelection/AccountSelection';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';

export const LinkedinEditConnector = () => {
  return (
    <AccountSelection
      title="LinkedIn"
      connectionSteps={FACEBOOK_CONNECTION_STEPS}
      selectedIcon={LinkedinWhiteConnectorIcon}
      unselectedIcon={LinkedinConnectorIcon}
    />
  );
};
